import styles from './Dashboard.module.css';

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format, formatDistanceToNow } from 'date-fns';
import { Link } from 'react-router-dom';
import { Statistic, Card, Row, Col, Spin, PageHeader, Button, Tooltip, List, Avatar, Tag } from 'antd';

import {
  ReloadOutlined
} from '@ant-design/icons';

import {
  getStatistics
} from 'store/ducks/dashboard.js';

import {
  getServicesHealth
} from 'store/ducks/health.js';

import {
  getActive
} from 'store/ducks/users.js';

const Dashboard = () => {
  const dispatch = useDispatch();

  const statistics = useSelector(state => state.dashboard.statistics);
  const servicesHealth = useSelector(state => state.health.servicesHealth);
  const active = useSelector(state => state.users.active);

  const getServicesHealthLoading = useSelector(state => state.health.getServicesHealth.loading);
  const getStatisticsLoading = useSelector(state => state.dashboard.getStatistics.loading);
  const getActiveLoading = useSelector(state => state.users.getActive.loading);

  const reload = () => {
    dispatch(getStatistics());
    dispatch(getServicesHealth());
    dispatch(getActive());
  };

  useEffect(() => {
    if (statistics === null) dispatch(getStatistics());
    if (active === null) dispatch(getActive());
  }, []);

  return (
    <>
      <PageHeader
        title="Dashboard"
        extra={[
          <Button onClick={() => reload()} key="reload"><ReloadOutlined /></Button>
        ]}
        style={{ border: '1px solid #f0f0f0', background: '#fff', margin: '0 0 15px 0' }}
      />

      <Card style={{ width: '100%' }}>
        <Row gutter={[15, 15]}>
          <Col span={6}>
            <Spin spinning={getStatisticsLoading} size="small">
              <Card>
                <Statistic
                  title="QuestionScout Accounts"
                  value={statistics ? statistics.usersCount.questionscout : 0}
                  precision={0}
                />
              </Card>
            </Spin>
          </Col>
          <Col span={6}>
            <Spin spinning={getStatisticsLoading} size="small">
              <Card>
                <Statistic
                  title="Onetool Users"
                  value={statistics ? statistics.usersCount.onetool : 0}
                  precision={0}
                />
              </Card>
            </Spin>
          </Col>
          <Col span={6}>
            <Spin spinning={getStatisticsLoading} size="small">
              <Card>
                <Statistic
                  title="Conversational Forms"
                  value={statistics ? statistics.formsCount.conversational : 0}
                  precision={0}
                />
              </Card>
            </Spin>
          </Col>
          <Col span={6}>
            <Spin spinning={getStatisticsLoading} size="small">
              <Card>
                <Statistic
                  title="Classic Forms"
                  value={statistics ? statistics.formsCount.classic : 0}
                  precision={0}
                />
              </Card>
            </Spin>
          </Col>
        </Row>

        <Row gutter={[15, 15]}>
          <Col span={6}>
            <Spin spinning={getActiveLoading} size="small">
              <Card>
                <Statistic
                  title="Active Users"
                  value={active ? active.length : 0}
                  precision={0}
                />
              </Card>
            </Spin>
          </Col>
          <Col span={6}>
            <Spin spinning={getStatisticsLoading} size="small">
              <Card>
                <Statistic
                  title="Submissions"
                  value={statistics ? statistics.submissionsCount : 0}
                  precision={0}
                />
              </Card>
            </Spin>
          </Col>
          <Col span={6}>
            <Spin spinning={getStatisticsLoading} size="small">
              <Card>
                <Statistic
                  title="Custom Themes"
                  value={statistics ? statistics.themesCount : 0}
                  precision={0}
                />
              </Card>
            </Spin>
          </Col>
          <Col span={6}>
            <Spin spinning={getServicesHealthLoading} size="small">
              <Card>
                <div className={styles.healthTitle}>Services Health</div>

                <ul className={styles.healthList}>
                  {servicesHealth && servicesHealth.map((service) => <li key={service._id} className={service.online ? styles.online : styles.offline}>
                    <Tooltip placement="top" title={service.name} arrowPointAtCenter>
                      <span />
                    </Tooltip>
                  </li>)}
                </ul>
              </Card>
            </Spin>
          </Col>
        </Row>

        {active && <List
          itemLayout="horizontal"
          header={<div>Active Users</div>}
          dataSource={active}
          renderItem={(item) => (
            <List.Item key={item._id}>
              <List.Item.Meta avatar={<Avatar shape="square" src={`https://d3djdih2k2vfi2.cloudfront.net/avatars/${item.owner ? item.owner._id : item._id}/${item._id}.png?hash=${
                item.avatar
              }`}>{!item.avatar && (item.name || item.email || '').charAt(0).toUpperCase()}</Avatar>} 
              title={<Link to={`/users/${item._id}`}>{item.email}{' '}<Tag>{item.role}</Tag></Link>} 
              description={<>{item.firstName}{' '}{item.lastName}{' '}{item.companyName && `@ ${item.companyName}`}</>} />
              <>
                {item.lifeTime && item.lifeTime.enabled && <Tag color="gold">LTD</Tag>}
                {item.billing.plan === 'personal' && <Tag color="geekblue">Personal</Tag>}
                {item.billing.plan === 'starter' && <Tag color="purple">Starter</Tag>}
                {item.billing.plan === 'pro' && <Tag color="orange">Pro</Tag>}
                {item.billing.plan === 'trial' && <Tag color="green">Trial, {item.billing.trialEnd && formatDistanceToNow(new Date(item.billing.trialEnd))} left</Tag>}
                {!item.billing.plan && <Tag color="red">Null</Tag>}
                {formatDistanceToNow(new Date(item.time))}
              </>
            </List.Item>
          )}
        />}
      </Card>
    </>
  );
}

export default Dashboard;
